import { render, staticRenderFns } from "./childView.vue?vue&type=template&id=45a64dc0&"
import script from "./childView.vue?vue&type=script&lang=js&"
export * from "./childView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports